import Cookies from 'js-cookie';
import { sendVerificationCode } from '@/services/user/user-service';

function countDown(_this, btnObj) {
  btnObj.time = --btnObj.time;
  Cookies.set(btnObj.storeKey + 'time', btnObj.time, { 'expires': 1 });
  if (btnObj.time <= 0) {
    btnObj.text = '获取验证码';
    btnObj.disabled = false;
    btnObj.time = 60;
    clearInterval(btnObj.inter);
    Cookies.set(btnObj.storeKey + 'disBtn', '');
    _this.init(btnObj);
    return false;
  } else {
    btnObj.text = btnObj.time + '秒后重新发送';
    _this.init(btnObj);
  }
}

export function initVerificationCodeStatus(_this, btnObj) {
  if (btnObj.disBtn === 'dis') {
    btnObj.disabled = true;
    btnObj.inter = setInterval(function() { countDown(_this, btnObj); }, 1000);
  }
}
export async function sendCode(_this, params, btnObj) {
  let { data } = await sendVerificationCode(params);
  if (data.returnCode === '01') {
    _this.$message.success('验证码发送成功！');
    if (!btnObj.disabled) {
      btnObj.time = 60;
      btnObj.disabled = true;
      Cookies.set(btnObj.storeKey + 'disBtn', 'dis', { 'expires': 1 });
      btnObj.inter = setInterval(function() { countDown(_this, btnObj); }, 1000);
    }
  } else {
    _this.$message.error('发送验证码失败，请检查网络连接！');
  }
}
